import React from 'react'
import {ANALYTICS_PATH} from 'constants/path'
import AnalyticsLayout from 'layouts/Analytics.layout'

const analyticsRoutes = [
  {
    path: 'analytics',
    element: <AnalyticsLayout />,
    handle: {title: 'Analytics'},
    children: [
      {
        path: ANALYTICS_PATH.OVERVIEW,
        handle: {title: 'Overview'},
        lazy: () => import('components/pages/Analytics/Overview'),
      },
      {
        path: ANALYTICS_PATH.INBOX,
        handle: {title: 'Inbox'},
        lazy: () => import('components/pages/Analytics/Conversations/Conversation'),
      },
      {
        path: ANALYTICS_PATH.TAGS,
        handle: {title: 'Tags'},
        lazy: () => import('components/pages/Analytics/Conversations/Tag'),
      },
      {
        path: ANALYTICS_PATH.CUSTOMER_SATISFACTION,
        handle: {title: 'Customer Satisfaction'},
        lazy: () => import('components/pages/Analytics/Conversations/CustomerSatisfaction'),
      },
      {
        path: ANALYTICS_PATH.METRICS,
        handle: {title: 'Metrics'},
        lazy: () => import('components/pages/Analytics/Performance/Metrix'),
      },
      {
        path: ANALYTICS_PATH.USERS,
        handle: {title: 'Users'},
        lazy: () => import('components/pages/Analytics/Performance/Users'),
      },
      {
        path: ANALYTICS_PATH.STAFFING_PREDICTION,
        handle: {title: 'Staffing Prediction'},
        lazy: () => import('components/pages/Analytics/Performance/StaffingPrediction'),
      },
      {
        path: ANALYTICS_PATH.SLA,
        handle: {title: 'SLA'},
        lazy: () => import('components/pages/Analytics/Performance/Sla'),
      },
      {
        path: ANALYTICS_PATH.ARTICLES,
        handle: {title: 'Articles'},
        lazy: () => import('components/pages/Analytics/KnowledgeBase/Articles'),
      },
      {
        path: ANALYTICS_PATH.SEARCHES,
        handle: {title: 'Searches'},
        lazy: () => import('components/pages/Analytics/KnowledgeBase/Searches'),
      },
      {
        path: ANALYTICS_PATH.TASKS_ANALYTICS,
        handle: {title: 'Tasks Analytics'},
        lazy: () => import('components/pages/Analytics/KnowledgeBase/TaskAnalytics'),
      },
      {
        path: ANALYTICS_PATH.ASSETS_ANALYTICS,
        handle: {title: 'Assets Analytics'},
        lazy: () => import('components/pages/Analytics/KnowledgeBase/AssetsAnalytics'),
      },
      {
        path: ANALYTICS_PATH.STATUS_PAGE,
        handle: {title: 'Status Page'},
        lazy: () => import('components/pages/Analytics/KnowledgeBase/StatusPage'),
      },
    ],
  },
]

export default analyticsRoutes
